module.exports = __webpack_public_path__ + "img/em9.edaa68a1.jpg";